import { useMemo } from 'react';

import { CoverageCatalog } from 'data-layer-cr/dist/models';

import COVERAGES_BENEFITS_LIST from 'src/constants/additionalCoverageBenefits';

type UseCoverageColectiveResumeResult = {
  regularCoverageCatalogs: CoverageCatalog[];
  additionalBenefits: CoverageCatalog[];
};

type Props = {
  quotationCoverages: CoverageCatalog[];
};

export default function useCoverageColectiveResume({
  quotationCoverages,
}: Props): UseCoverageColectiveResumeResult {
  return useMemo(() => {
    const coverageList = quotationCoverages.filter(
      (c) => !COVERAGES_BENEFITS_LIST.includes(c.code),
    );
    const aditionalBenefitsList = quotationCoverages.filter((c) =>
      COVERAGES_BENEFITS_LIST.includes(c.code),
    );
    return {
      regularCoverageCatalogs: coverageList,
      additionalBenefits: aditionalBenefitsList,
    };
  }, [quotationCoverages]);
}
